import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import GoogleButton from "@/components/GoogleButton";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/app/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <p className="font-mono text-xs uppercase tracking-widest text-[#CCFF00] mb-3">// welcome back</p>
      <h1 className="font-display font-black text-5xl tracking-tighter mb-8">Log in.</h1>
      <GoogleButton testId="login-google-btn" label="Continue with Google" />
      <div className="my-6 flex items-center gap-3 text-xs font-mono uppercase tracking-widest text-neutral-500">
        <span className="flex-1 h-px bg-white/10" /> or <span className="flex-1 h-px bg-white/10" />
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Input
          type="email"
          placeholder="you@creator.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="h-12 bg-[#0e0e0e] border-white/10 focus-visible:ring-[#CCFF00] focus-visible:border-[#CCFF00]"
          data-testid="login-email-input"
        />
        <Input
          type="password"
          placeholder="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="h-12 bg-[#0e0e0e] border-white/10 focus-visible:ring-[#CCFF00] focus-visible:border-[#CCFF00]"
          data-testid="login-password-input"
        />
        <Button
          type="submit"
          disabled={busy}
          className="w-full h-12 rounded-full bg-[#CCFF00] text-black hover:bg-[#b8e600] font-semibold"
          data-testid="login-submit-btn"
        >
          {busy ? "Logging in…" : "Log in"}
        </Button>
      </form>
      <p className="mt-6 text-sm text-neutral-400">
        No account?{" "}
        <Link to="/signup" className="text-[#CCFF00] hover:underline" data-testid="login-goto-signup">
          Claim your handle
        </Link>
      </p>
    </div>
  );
}
